import { render } from "./termination-list.vue?vue&type=template&id=02610d9d"
import script from "./termination-list.vue?vue&type=script&lang=js"
export * from "./termination-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__